import { useTranslations } from '@/hooks/useTranslations'

import type { Product } from '@/gen/ecom'

export const useSalesUnitDescription = (productData?: Product) => {
  const { translate } = useTranslations()

  if (!productData?.packageSalesUnit || !productData?.packageUnit || !productData?.packageQuantity) {
    return 'N/A'
  }

  const packageSalesUnit = translate(`page.product.details.salesUnit.${productData?.packageSalesUnit?.toLowerCase()}`)
  const packageUnitQuantity = productData?.packageQuantity
  const packageUnit = translate(`page.product.details.salesUnit.${productData?.packageUnit?.toLowerCase()}`)

  return `${packageSalesUnit} a ${packageUnitQuantity} ${packageUnit}`
}
